import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ChakraProvider, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Text } from '@chakra-ui/react'; // Import ChakraProvider, Breadcrumb, BreadcrumbItem, BreadcrumbLink, and Text
import Home from './Home';
import PrimeRibCalculator from './components/PrimeRibCalculator';
import PrivacyPolicy from './PrivacyPolicy';
import Blog from './Blog';
import { init, track } from '@amplitude/analytics-browser'; // Import Amplitude
import CookiesPolicy from './Cookies';

function App() {
  useEffect(() => {
    // Initialize Amplitude with your API key
    init('96416d27148abdab2ce4bc7a12631c02');
    track('App Loaded'); // Track when the app is loaded
  }, []);

  return (
    <ChakraProvider>
      <Router>
        <Box minHeight="100vh" display="flex" flexDirection="column" justifyContent="space-between" alignItems="center">
          {/* Main Content */}
          <Box p={4} flex="1" width="100%" maxWidth="800px">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/prime-rib" element={<PrimeRibCalculator />} />
              <Route path="/blog/:blogId" element={<Blog />} /> {/* Adding a route to display individual blog */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookies" element={<CookiesPolicy />} />
              <Route path="/blog" element={<Blog />} />
            </Routes>
          </Box>

          {/* Footer Breadcrumb Links */}
          <Box as="footer" p={4} bg="gray.100" width="100%" maxWidth="800px" textAlign="center">
            <Breadcrumb separator="|" justifyContent="center" textAlign="center" display="flex" alignItems="center">
              <BreadcrumbItem>
                <BreadcrumbLink href="/" color="teal.500">
                  Calculators
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="/privacy-policy" color="teal.500">
                  Privacy Policy
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="/cookies" color="teal.500">
                  Cookies
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="/blog" color="teal.500">
                  Blog
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="https://w1uc73q5mye.typeform.com/to/X3Wvt4i5" isExternal color="teal.500" target="_blank">
                  Submit Feedback
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="https://buymeacoffee.com/groakmunchv" isExternal color="teal.500" target="_blank">
                  Donate ☕️
                </BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            <Text textAlign="center" mt={4} fontSize="sm" color="gray.600">
              Cook Time Calculator. Made by Marak.
            </Text>
          </Box>
        </Box>
      </Router>
    </ChakraProvider>
  );
}

export default App;
